// test927
(927 && 0);
